export const SIGNIN = '/signin';
export const SIGNUP = '/signup';
export const RESET_PASSWORD = '/signin/reset-password';

const isProd = process.env.NODE_ENV === 'production';

const createPath = path => (isProd ? path : `http://localhost:8080${path}`);

export const MARVELAPP_PROJECTS = createPath('/projects');
export const MARVELAPP_ONBOARDING = createPath('/onboarding');



// WEBPACK FOOTER //
// ./src/constants/urls.js